import { getAPIUrl } from '../helpers/App';

export const APIgetGroup = groupUuid => (
  window.axios.get(getAPIUrl(`/groups/${groupUuid}`))
    .then(response => (response))
);

export const APIcreateGroup = group => (
  window.axios.post(getAPIUrl('/groups'), { group })
    .then(response => (response))
);

export const APIupdateGroup = group => (
  window.axios.patch(getAPIUrl(`/groups/${group.uuid}`), { group })
    .then(response => (response))
);

export const APIdeleteGroup = groupUuid => (
  window.axios.delete(getAPIUrl(`/groups/${groupUuid}`))
    .then(response => (response))
);

export const APIupdateGroupCapabilities = (groupUuid, capabilities) => (
  window.axios.patch(getAPIUrl(`/groups/${groupUuid}/capabilities`), { capabilities })
    .then(response => (response))
);

export const APIupdateGroupMembers = (groupUuid, members) => (
  window.axios.patch(getAPIUrl(`/groups/${groupUuid}/members`), { members })
    .then(response => (response))
);

export const APIgetGroups = params => (
  window.axios.get(getAPIUrl('/groups'), { params })
    .then(response => (response))
);

export const APIgetGroupCapabilities = () => (
  window.axios.get(getAPIUrl('/groups/capabilities'))
    .then(response => (response))
);
